"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlastAbilityHandler = exports.BlastActorAbilityFactory = exports.BlastAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
class BlastAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Blast;
        this.__typeName = "Blast";
    }
}
exports.BlastAbilityArgs = BlastAbilityArgs;
let BlastActorAbilityFactory = class BlastActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Blast", "OneEnemies", 0);
    }
};
BlastActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Blast")
], BlastActorAbilityFactory);
exports.BlastActorAbilityFactory = BlastActorAbilityFactory;
let BlastAbilityHandler = class BlastAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Holy", 50)
            ],
            projectileType: "LightBlueComet",
            projectilePath: "line",
        });
    }
};
BlastAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Blast)
], BlastAbilityHandler);
exports.BlastAbilityHandler = BlastAbilityHandler;
